/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Courier } from './Courier'
import { WaitingForCourier } from './WaitingForCourier'
import { Divider, Segment } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

const Couriers = ({ couriers, expectedCouriers, orderStatus }) => {
    const [t] = useTranslation()
    const placeholdersCount = orderStatus === 'COMPLETED' ?
      0 :
      Math.max(expectedCouriers - couriers.length, 0)

    const dividerStyle = css`&.ui.divider { margin: .5rem 0; }`

    if (orderStatus === 'COMPLETED' && couriers.length === 0) {
        return null
    }

    return (
      <Segment
        css={css`
            &.ui.segment {
                margin-bottom: 0;
            }
        `}
      >
          {couriers.map((courier, index) => (
            <div key={courier.externalId}>
                <Courier courier={{
                    ...courier,
                    name: courier?.name === 'Deliveroo Rider' ? t('order.delivery.courier_x', { count: index + 1 }) : courier?.name,
                }} />
                {(index < couriers.length - 1 || placeholdersCount > 0) && <Divider css={dividerStyle} />}
            </div>
          ))}

          {orderStatus !== 'COMPLETED' && [...Array(placeholdersCount)].map((_, index) => (
            <div key={`waiting-${index}`}>
                <WaitingForCourier />
                {index < placeholdersCount - 1 && <Divider css={dividerStyle} />}
            </div>
          ))}
      </Segment>
    )
}

export { Couriers }
